import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Principles } from '../components/Principles';
import { Guarantee } from '../components/Guarantee';
import { ProofPanel } from '../components/ProofPanel';
import { HowWeWork } from '../components/HowWeWork';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function WhyViridia() {
  usePageTitle('Why Viridia | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Why Viridia" title="You are not buying software. You are hiring a vendor who has to earn next month." data-id="element-568" data-mp="1vs85i93t5ax3" />
      <Principles data-id="element-569" data-mp="29r7ksq5fkdgl" />
      <Guarantee data-id="element-570" data-mp="29pmx9khj9us8" />
      <ProofPanel data-id="element-571" data-mp="25q5repy72vmj" />
      <HowWeWork data-id="element-572" data-mp="25pm752l2nv5c" />
      <NextStepPanel title="See exactly what we build." buttonLabel="What we offer" to="/services" data-id="element-573" data-mp="25r722tbatg3q" />
    </>;
}